import React from "react"
import { type CategoryType, type TransactionSummary } from "@digits-graphql/frontend/graphql-bearer"
import moneyFlowHelper from "@digits-shared/helpers/moneyFlowHelper"
import { isBalanceSheetCategory } from "src/shared/helpers/categoryHelper"

export const useOpeningEndingMoneyFlow = ({
  categoryType,
  summary: {
    total: { value, deltaPrevious, moneyFlow, prior },
  },
}: {
  summary: TransactionSummary
  categoryType: CategoryType | undefined
}) => {
  const endingMoneyFlow = React.useMemo(
    () =>
      moneyFlow || {
        value,
        businessFlow: moneyFlowHelper.amountBusinessFlow(value.amount),
        isNormal: true,
      },
    [moneyFlow, value]
  )

  const openingMoneyFlow = React.useMemo(
    () =>
      moneyFlowHelper.calculateOpeningMoneyFlow(
        prior?.total,
        endingMoneyFlow,
        deltaPrevious,
        (categoryType && isBalanceSheetCategory(categoryType)) || false
      ),
    [categoryType, deltaPrevious, endingMoneyFlow, prior]
  )

  return React.useMemo(
    () => ({
      openingMoneyFlow,
      endingMoneyFlow,
    }),
    [openingMoneyFlow, endingMoneyFlow]
  )
}
